/* eslint-disable jsx-a11y/interactive-supports-focus */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { getImageFile } from 'utils/stringUtils';
import _get from 'lodash/get';
import { Link } from 'react-router-dom';
import RichTextReactRenderer from 'components/RichTextReactRenderer';
import useSiteCopySelector from 'components/useSiteCopySelector';
import parser, { domToReact } from 'html-react-parser';
import StyledLink from 'components/StyledLink';

import RightArrow from '../../images/arrow-right.svg';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    [theme.breakpoints.down('960')]: {
      flexDirection: 'column',
    },
  },
  img: {
    height: 213,
    width: 375,
    marginRight: 38,
    objectFit: 'cover',
    [theme.breakpoints.down('960')]: {
      width: '100%',
      height: 'auto',
      marginBottom: 20,
    },
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 386,
    justifyContent: 'space-between',
    [theme.breakpoints.down('960')]: {
      maxWidth: '100%',
    },
  },
  rtWrapper: {
    [theme.breakpoints.down('960')]: {
      margin: '20px 0',
    },
    '& p': {
      margin: 0,
      fontSize: '1.0625rem',
    },
  },
  btnLink: {
    textDecoration: 'none',
    background: '#ECF4F8',
    height: 38,
    width: 106,
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      marginLeft: 5,
    },
  },
  description: {
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '3',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '1.0625rem',
  },
}));

function BlogMainItem({ data, isLatest, clickHandler, resourceType }) {
  const classes = useStyles();
  const [siteCopy] = useSiteCopySelector(['resource-item-page']);
  const imageSrc = getImageFile(data);
  const { slug, name, description } = data;
  return (
    <StyledLink
      link={`/${resourceType === 'news' ? 'articles' : 'insights'}/${slug}`}
    >
      <div className={classes.root} data-test-id="blog-main">
        <div role="button" onClick={() => clickHandler(name, 'image')}>
          <img src={imageSrc} alt={name} className={classes.img} />
        </div>
        <div
          className={classes.info}
          role="button"
          onClick={() => clickHandler(name, 'text')}
        >
          <Typography
            variant="subtitle2"
            className={classes.name}
            color="textPrimary"
          >
            {name}
          </Typography>
          <div className={classes.rtWrapper}>
            {isLatest ? (
              <RichTextReactRenderer
                data={description}
                limit={200}
                hideReadText
              />
            ) : (
              <Typography
                variant="overline"
                color="textPrimary"
                className={classes.description}
              >
                {parser(description, {
                  // eslint-disable-next-line react/prop-types
                  replace: ({ type, name: nodeName, attribs, children }) => {
                    if (type === 'tag' && nodeName === 'a') {
                      return (
                        <Link
                          // eslint-disable-next-line react/prop-types
                          to={attribs.href}
                          // eslint-disable-next-line react/prop-types
                          className={attribs.class}
                          onClick={e => e.stopPropagation()}
                        >
                          {domToReact(children)}
                        </Link>
                      );
                    }
                    return null;
                  },
                })}
              </Typography>
            )}
          </div>
          <div className={classes.btnLink}>
            {_get(siteCopy, ['pageCopy', 'readMoreLabel'])}
            <img src={RightArrow} alt="" />
          </div>
        </div>
      </div>
    </StyledLink>
  );
}

BlogMainItem.propTypes = {
  data: PropTypes.object,
  isLatest: PropTypes.bool,
  clickHandler: PropTypes.func,
  resourceType: PropTypes.string,
};

export default BlogMainItem;
